import React, { useState } from "react";

import {
  Divider,
  Grid2,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Paper,
  Skeleton,
  Stack,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa6";
import { RxDotsHorizontal } from "react-icons/rx";
import {
  Cancel,
  Cloud,
  ContentCopy,
  ContentCut,
  ContentPaste,
  MoreVert,
  TaskAlt,
} from "@mui/icons-material";
import { HiOutlineDocumentDownload } from "react-icons/hi";
import { VscGraph } from "react-icons/vsc";
import { ReactComponent as NewViewIcon } from "assets/PwC_Funct_Icons_View_Outline_Black_RGB.svg"
import { ReactComponent as MoreIcon } from "assets/PwC_Funct_Icons_MoreVertical_Outline_Black_RGB.svg"
import { ReactComponent as EditIcon } from "assets/PwC_Funct_Icons_Edit_Outline_Black_RGB.svg"
import {ReactComponent as DeleteIcon} from "assets/PwC_Funct_Icons_Delete_Outline_Black_RGB.svg"
import {ReactComponent as  RejectIcon} from "assets/PwC_Funct_Icons_CircleDelete_Fill_Black_RGB.svg"
import {ReactComponent as  ApproveIcon} from "assets/PwC_Funct_Icons_CircleCheckmark_Outline_Black_RGB.svg"
import {ReactComponent as BarGraphIcon} from "assets/PwC_Funct_Icons_BarGraph_Outline_Black_RGB.svg"

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: "10px",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: "0 !important",
  },
}));


const TableComponent = (props) => {
  const {
    data,
    columns,
    actionDelete,
    actionEdit,
    actionView,
    actionAccept,
    actionReject,
    actionDownload,
    actionResult,
    isLoading
  } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{ borderCollapse: "separate" }}
        >
          <TableHead>
            <TableRow sx={{ borderBottom: "1px solid #D1D1D1 !important" }}>
              {columns?.map((col, index) =>
                isLoading ? (
                  <StyledTableCell key={`header-skeleton-${index}`}>
                    <Skeleton variant="text" width={80} height={24} />
                  </StyledTableCell>
                ) :
                  col?.field === "issueNumber" ||
                    col?.field === "clearance_number" ||
                    col?.field === "risk_number" ||
                    col?.field === "safety_number" ||
                    // col?.field === "change_number" ||
                    // col?.field === "claim_number" ||
                    col?.field === "ncrNumber" ||
                    col?.field === "pm_number" ? (
                    <StyledTableCell
                      sx={{
                        whiteSpace: "nowrap",
                        color: "#252525",
                        // border: "none",
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fff",
                        zIndex: 2,
                      }}
                      key={`${col?.name}-${index}`}
                    >
                      {col?.name}
                    </StyledTableCell>
                  ) : (
                    <StyledTableCell
                      sx={{
                        whiteSpace: !col?.width && 'nowrap',
                        color: "#252525",
                        maxWidth: col?.width || 'auto'
                        // border: "none",
                      }}
                      key={`${col?.name}-${index}`}
                    >
                      {col?.name}
                    </StyledTableCell>
                  )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              Array.from(new Array(5)).map((_, i) => (
                <StyledTableRow key={`skeleton-${i}`}>
                  {columns?.map((_, j) => (
                    <StyledTableCell key={j}>
                      <Skeleton variant="text" width="100%" height={30} />
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : data?.length > 0 ? (
              data?.map((row, index) => (
                <StyledTableRow key={index}>
                  {columns?.map((col, ind) =>
                    col?.name === "Action" ? (
                      <StyledTableCell
                        key={`${col.name}-${ind}`}
                        align="center"
                      >
                        {col.name === "#" ? (
                          row[col.field]
                        ) : (
                          <Stack direction="row" alignContent={"center"}>
                            {col?.option?.view && (
                              <Tooltip
                                placement="top"
                                title="View"
                                arrow
                                slotProps={{
                                  tooltip: { sx: { fontSize: "12px" } },
                                }}
                              >
                                <IconButton
                                  aria-label="view"
                                  size="small"
                                  onClick={() => actionView(row)}
                                >
                                  {/* <FaRegEye /> */}
                                  <NewViewIcon style={{ height: "24px", width: "26px", fill: "#252525" }} />
                                </IconButton>
                              </Tooltip>
                            )}
                            {col?.option?.edit && (row['currentStatus']?.toLowerCase() !== "close" && row['status']?.toLowerCase() !== "close") && (
                              <Tooltip
                                placement="top"
                                title={col?.option?.tooltip ? "Add actual date" : "Edit"}
                                arrow
                                slotProps={{
                                  tooltip: { sx: { fontSize: "12px" } },
                                }}
                              >
                                <IconButton
                                  aria-label="Edit Issue"
                                  size="small"
                                  onClick={() => actionEdit(row)}
                                >
                                   {/* <FaRegEdit /> */}
                                  <EditIcon style={{ width: "20px", height: "20px" }} />
                                </IconButton>
                              </Tooltip>
                            )}

                            {col?.option?.delete && (row['currentStatus']?.toLowerCase() !== "close" && row['status']?.toLowerCase() !== "close") && (
                              <Tooltip
                                placement="top"
                                title="Delete"
                                arrow
                                slotProps={{
                                  tooltip: { sx: { fontSize: "12px" } },
                                }}
                              >
                                <IconButton
                                  aria-label="delete"
                                  size="small"
                                  onClick={() => actionDelete(row)}
                                >
                                   {/* <MdOutlineDeleteOutline /> */}
                                  <DeleteIcon style={{width:"20px", height:"20px"}} />
                                </IconButton>
                              </Tooltip>
                            )}
                            {col?.option?.download && (
                              <Tooltip
                                placement="top"
                                title="Download"
                                arrow
                                slotProps={{
                                  tooltip: { sx: { fontSize: "12px" } },
                                }}
                              >
                                <IconButton
                                  aria-label="download"
                                  size="small"
                                  onClick={() => actionDownload(row)}
                                >
                                  <HiOutlineDocumentDownload />
                                </IconButton>
                              </Tooltip>
                            )}
                            {col?.option?.editOfDocument && row['status'] == "Rejected" && (
                              <Tooltip
                                placement="top"
                                title={col?.option?.tooltip ? "Add actual date" : "Edit"}
                                arrow
                                slotProps={{
                                  tooltip: { sx: { fontSize: "12px" } },
                                }}
                              >
                                <IconButton
                                  aria-label="Edit Issue"
                                  size="small"
                                  onClick={() => actionEdit(row)}
                                >
                                   {/* <FaRegEdit /> */}
                                  <EditIcon style={{ width: "12px", height: "12px" }} />
                                </IconButton>
                              </Tooltip>
                            )}
                            {col?.option?.result && (
                              <Tooltip
                                placement="top"
                                title={"View Result"}
                                arrow
                                slotProps={{
                                  tooltip: { sx: { fontSize: "12px" } },
                                }}
                              >
                                <IconButton
                                  aria-label="View Result"
                                  size="small"
                                  onClick={() => actionResult(row)}
                                >
                                   {/* <VscGraph /> */}
                                  <BarGraphIcon style={{width: "20px", height: "20px" }} />
                                </IconButton>
                              </Tooltip>
                            )}
                            {col?.option?.acceptReject && (
                              <div>
                                <IconButton
                                  onClick={(event) => handleClick(event, row)}
                                  size="small"
                                >
                                   {/* <MoreVert /> */}
                                  <MoreIcon style={{ height: "20px", width: "20px", fill: "#252525" }} />
                                </IconButton>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose}
                                  PaperProps={{
                                    sx: {
                                      width: 320,
                                      maxWidth: "100%",
                                      boxShadow: "none",
                                      border: "1px solid #eee",
                                    },
                                  }}
                                >
                                  <MenuList>
                                    <MenuItem
                                      onClick={handleClose}
                                      sx={{
                                        backgroundColor: "#F3F3F3",
                                        margin: "5px 8px"
                                      }}
                                    >
                                      <ListItemText>Action</ListItemText>
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        if (selectedRow) {
                                          actionAccept(selectedRow); // Now it correctly gets the row data
                                        }
                                        handleClose();
                                      }}
                                    >
                                      <ListItemIcon>
                                         {/* <TaskAlt fontSize="small" /> */}
                                        <ApproveIcon style={{width:"25px", height:"25px", fill:"#474747"}} />
                                      </ListItemIcon>
                                      <ListItemText
                                        sx={{
                                          color: "#474747",
                                        }}
                                      >
                                        Approve
                                      </ListItemText>
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        if (selectedRow) {
                                          actionReject(selectedRow);
                                        }
                                        handleClose();
                                      }}
                                    >
                                      <ListItemIcon>
                                        {/* <Cancel fontSize="small" /> */}
                                        <RejectIcon style={{width:"25px", height:"25px", fill:"#474747"}} />
                                      </ListItemIcon>
                                      <ListItemText
                                        sx={{
                                          color: "#474747",
                                        }}
                                      >
                                        Reject
                                      </ListItemText>
                                    </MenuItem>
                                  </MenuList>
                                </Menu>
                              </div>
                            )}
                          </Stack>
                        )}
                      </StyledTableCell>
                    ) : col?.field === "issueNumber" ||
                      col?.field === "clearance_number" ||
                      col?.field === "risk_number" ||
                      col?.field === "safety_number" ||
                      // col?.field === "change_number" ||
                      // col?.field === "claim_number" ||
                      col?.field === "ncrNumber" ||
                      col?.field === "pm_number" ? (
                      <StyledTableCell
                        sx={{
                          whiteSpace: "nowrap",
                          color: "#252525",
                          // border: "none",
                          position: "sticky",
                          left: 0,
                          borderBottom: "1px solid #D1D1D1 !important",
                          backgroundColor: "#fff",
                          zIndex: 2,
                        }}
                        key={`${col.name}-${ind}`}
                      >
                        {col.renderer ? col.renderer(row) : row[col.field]}
                      </StyledTableCell>
                    ) : (
                      <StyledTableCell
                        sx={{
                          whiteSpace: !col?.width && 'nowrap',
                          maxWidth: col?.width || 'auto',
                          color: "#474747",
                          borderBottom: "1px solid #D1D1D1 !important",
                        }}
                        key={`${col.name}-${ind}`}
                        component="th"
                        scope="row"
                      >
                        {col.renderer ? col.renderer(row) : row[col.field]}
                      </StyledTableCell>
                    )
                  )}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={columns?.length}>
                  Record not found.
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableComponent;
